import React, { useState } from 'react';
import "./careers.css";
import careerim from "../../assets/careerim.png";
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Helmet } from 'react-helmet';
import Swal from 'sweetalert2';
import BASE_URL from "../../config.js";

const Careers = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    nationality: '',
    jobRole: 'Primary Role Interested in',
    experience: '',
    consent: false
  });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.jobRole === 'Primary Role Interested in') {
      Swal.fire({ icon: 'warning', title: 'Selection Required', text: 'Please select a primary role.' });
      return;
    }

    if (!file) {
      Swal.fire({ icon: 'warning', title: 'File Required', text: 'Please upload your CV/Resume.' });
      return;
    }

    if (!formData.consent) {
      Swal.fire({ icon: 'warning', title: 'Consent Required', text: 'Please provide consent to contact you.' });
      return;
    }

    setLoading(true);
    Swal.fire({
      title: 'Submitting...',
      text: 'Please wait while we process your application.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const submitData = new FormData();
    submitData.append('first_name', formData.firstName);
    submitData.append('last_name', formData.lastName);
    submitData.append('email', formData.email);
    submitData.append('phone_number', formData.phone);
    submitData.append('nationality', formData.nationality);
    submitData.append('jobrole', formData.jobRole);
    submitData.append('years_of_experience', formData.experience);
    submitData.append('handmade_contact', formData.consent ? '1' : '0');
    submitData.append('resumeup', file);

    try {
      // Try production first, or change to /api/ if on same domain
      const apiUrl = window.location.hostname === 'localhost' 
        ? `${BASE_URL}/api/resume-upload.php` 
        : '/api/resume-upload.php';

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: submitData,
        // Mode 'cors' is default for cross-origin, but we ensure it works
        mode: 'cors' 
      });

      if (!response.ok) {
        throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
      }

      const text = await response.text();
      let result;
      try {
        result = JSON.parse(text);
      } catch (e) {
        console.error('Non-JSON response:', text);
        throw new Error('Server returned an invalid response format.');
      }

      if (result.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Application Received!',
          text: result.message,
        });
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          nationality: '',
          jobRole: 'Primary Role Interested in',
          experience: '',
          consent: false
        });
        setFile(null);
        if(document.getElementById('down')) document.getElementById('down').value = '';
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Submission Error',
          text: result.message || 'The server encountered an issue. Please try again.',
        });
      }
    } catch (error) {
      console.error('Submission error details:', error);
      Swal.fire({
        icon: 'error',
        title: 'Network Error',
        text: error.message || 'Could not connect to the career portal server.',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Careers | Vasmi Group</title>
      </Helmet>

      <div className='career'>
        <img src={careerim} alt='career hero' className='career-land' />

        <div className="form-recruit-r">
          <p className="platform-heading-r">Keen to work with Vasmi Group?</p>

          <div className="forms-flex-container">
            <div className="recruit-formm" style={{ flex: "1 1 400px", maxWidth: "500px" }}>
              <p className="submit-recruit-p">Submit your CV</p>
              <form onSubmit={handleSubmit}>
                <div className="form-inps-recruit">
                  <input 
                    type="text" 
                    name="firstName" 
                    placeholder="First Name" 
                    required 
                    value={formData.firstName}
                    onChange={handleInputChange}
                  />
                  <input 
                    type="text" 
                    name="lastName" 
                    placeholder="Last Name" 
                    required 
                    value={formData.lastName}
                    onChange={handleInputChange}
                  />
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="Email" 
                    required 
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                  <input 
                    type="text" 
                    name="phone" 
                    placeholder="Phone Number" 
                    required 
                    value={formData.phone}
                    onChange={handleInputChange}
                  />
                  <input 
                    type="text" 
                    name="nationality" 
                    placeholder="Nationality" 
                    required 
                    value={formData.nationality}
                    onChange={handleInputChange}
                  />
                  <select 
                    name="jobRole" 
                    required 
                    value={formData.jobRole}
                    onChange={handleInputChange}
                  >
                    <option value="Primary Role Interested in">Primary Role Interested in</option>
                    <option value="Frontend Developer">Frontend Developer</option>
                    <option value="Digital Marketing Executive">Digital Marketing Executive</option>
                    <option value="Graphic Designer">Graphic Designer</option>
                    <option value="Full Stack Developer">Full Stack Developer</option>
                    <option value="Content Writer">Content Writer</option>
                    <option value="SEO Specialist">SEO Specialist</option>
                  </select>
                  <input 
                    type="text" 
                    name="experience" 
                    placeholder="Years Of Experience" 
                    required 
                    value={formData.experience}
                    onChange={handleInputChange}
                  />
                  <input
                    style={{ border: "none" }}
                    type="file"
                    name="resumeup"
                    id="down"
                    onChange={handleFileChange}
                    accept=".pdf,.doc,.docx"
                  />
                </div>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="consent"
                        checked={formData.consent}
                        onChange={handleInputChange}
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 28,
                          },
                        }}
                      />
                    }
                    label="I consent to Vasmi Group contacting me via the information that I have provided."
                    sx={{
                      "& .MuiTypography-root": {
                        fontSize: 14,
                        color: "black",
                      },
                    }}
                  />
                </FormGroup>
                <button type="submit" className="contact-btn r-btn" disabled={loading}>
                  {loading ? 'Submitting...' : 'Submit'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Careers;
